import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { ShimmerText, ShimmerTitle } from 'react-shimmer-effects'

const CustomShimmerPayment = () => {
  return (
    <Row className='cursor-pointer border-radius-5 p-32px custom-thumbnail-bg'>
      <Col xl={12} lg={12} md={12} sm={12} className='pt-3'>
        <ShimmerTitle line={1} />
        <ShimmerText line={1} gap={15} />
      </Col>
      <Row className='d-flex justify-content-between'>
        <Col xl={4} lg={4} md={4} sm={4} className='pt-3'>
          <ShimmerTitle line={1} />
          <ShimmerTitle line={1} />
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} className='pt-3'>
          <ShimmerTitle line={1} />
          <ShimmerTitle line={1} />
        </Col>
      </Row>
      <Col xl={12} lg={12} md={12} sm={12} className='pt-3'>
        <ShimmerText line={1} gap={15} />
      </Col>
      <Row className='d-flex justify-content-between'>
        <Col xl={4} lg={4} md={4} sm={4} className='pt-3'>
          <ShimmerTitle line={1} />
        </Col>
        <Col xl={2} lg={2} md={2} sm={2} className='pt-3'>
          <ShimmerTitle line={1} />
        </Col>
      </Row>
      <Col xl={12} lg={12} md={12} sm={12} className=''>
        <ShimmerText line={2} gap={15} />
      </Col>
    </Row>
  )
}

export default CustomShimmerPayment
